import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function MediaView({ path, kind = "image", className = "" }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!path) return undefined;
    let revoke;
    let cancelled = false;
    api.get(`/files/${path}`, { responseType: "blob" })
      .then((r) => {
        if (cancelled) return;
        const url = URL.createObjectURL(r.data);
        revoke = url;
        setSrc(url);
      })
      .catch((e) => {
        console.error(`Failed to load media ${path}:`, e);
      });
    return () => {
      cancelled = true;
      if (revoke) URL.revokeObjectURL(revoke);
    };
  }, [path]);

  if (!src) return <div className={`bg-cream-surface ${className}`} />;
  if (kind === "video") return <video src={src} controls className={className} />;
  return <img src={src} alt="" className={className} />;
}
